export var DEFAULT_NOTIFICATIONS = {};